import axios from "axios";
import {isExpired, decodeToken} from "react-jwt";
import AppContext from "../contexts/appContext/app.context";


const api = axios.create({
    baseURL: 'https://fleet.networkite.com'
});

// ..... adding headers ....
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        const smlToken = localStorage.getItem('smlToken');

        if (token) config.headers.Authorization = token;
        if (smlToken) config.headers.smltoken = smlToken;
        // config.headers.hosturl = 'https://dev.smnp.adsdcsp.com';

        return config;
    },
    (error) => Promise.reject(error)
)

api.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;

        const token = localStorage.getItem('token');
        const decodedToken = decodeToken(token);
        const isTokenExpired = isExpired(token);

        if (isTokenExpired || (error.response.status === 401 && !originalRequest._retry)) {
            originalRequest._retry = true;
            try {
                const refreshToken = localStorage.getItem('refreshToken');
                const smlToken = localStorage.getItem('smlToken');
                const response = await axios.get('https://fleet.networkite.com/api/auth/refresh_session_token',
                    {
                        headers: {
                            uname: decodedToken.username,
                            Rtoken: refreshToken,
                            Smltoken: smlToken
                        }
                    })

                console.log('refresh token...');

                const tokens = response.data;

                if (tokens?.token) localStorage.setItem('token', tokens.token);
                if (tokens?.idToken) localStorage.setItem('idToken', tokens.idToken);
                if (tokens?.refreshToken) localStorage.setItem('refreshToken', tokens.refreshToken);

                // Retry the original request with the new token
                originalRequest.headers.Authorization = tokens.token;
                return axios(originalRequest);
            } catch (e) {
                console.log('refresh failed and redirected...');
                localStorage.clear();
                window.location.href = '';
            }
        }

        return Promise.reject(error);
    }
)


export default api;
